<div *ngIf="broadcastMessages.length > 0">
  <h2 class="section-header">Announcements</h2>
  <div class="grid-row announcement" *ngFor="let msg of broadcastMessages">
    <div class="date-item grid-col-2">
      <div class="date-entry">{{msg.messageStartDate | date: 'MMM. dd'}}
      </div>
    </div>
    <div class="story-item grid-col-8">{{msg.messageText}}</div>
  </div>
</div>
